/* eslint-disable camelcase */
/* eslint-disable no-redeclare */
/* eslint-disable block-scoped-var */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable no-unused-expressions */
/* eslint-disable import/no-named-as-default-member */
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';

import {
  CREATE_CERTIFICATE_STUDENT,
  DELETE_CERTIFICATE_STUDENT,
  GET_CERTIFICATE_STUDENT,
  UPDATE_CERTIFICATE_STUDENT,
} from '../../../types/masterclass/certificateStudentTypes';

import { axiosPut, del, get, post } from '../../../../ApiConfig';
import {
  createCertificateStudentFailed,
  createCertificateStudentSuccessful,
  deleteCertificateStudentFailed,
  deleteCertificateStudentSuccessful,
  getCertificateStudents,
  getCertificateStudentsFailed,
  getCertificateStudentsSuccessful,
  updateCertificateStudentFailed,
  updateCertificateStudentSuccessful,
} from './actions';

// get_certificate_student
const getCertificateStudentsAsync = (id) => {
  return get(
    `/admin/course/course/certificate/${id}/assign/all`,
    { params: { page: 1, limit: 1000 } },
    { notifyError: true }
  );
};
function* GetCertificateStudents({ payload: { id } }) {
  try {
    const response = yield call(getCertificateStudentsAsync, id);
    yield put(getCertificateStudentsSuccessful({ data: response.data }));
  } catch (error) {
    yield put(getCertificateStudentsFailed({ error, data: [] }));
  }
}

// create_certificate_student
const createCertificateStudentAsync = (payload) => {
  return post(
    '/admin/course/course/certificate/assign',
    payload,
    {},
    { notify: true }
  );
};
function* CreateCertificateStudent({ payload: { onSuccess, ...payload } }) {
  try {
    const response = yield call(createCertificateStudentAsync, payload);
    yield put(createCertificateStudentSuccessful(response.data));
    onSuccess?.(response.data);
    yield put(getCertificateStudents({ id: payload.certificate_id }));
  } catch (error) {
    yield put(createCertificateStudentFailed(error));
  }
}

// update_certificate_student
const updateCertificateStudentAsync = ({ id, ...payload }) => {
  return axiosPut(
    `/admin/course/course/certificate/assign/${id}`,
    payload,
    {},
    { notify: true }
  );
};
function* UpdateCertificateStudent({ payload: { onSuccess, ...payload } }) {
  try {
    const response = yield call(updateCertificateStudentAsync, payload);
    yield put(updateCertificateStudentSuccessful(response.data));
    onSuccess?.(response.data);
    yield put(getCertificateStudents({ id: payload.id }));
  } catch (error) {
    yield put(updateCertificateStudentFailed(error));
  }
}

// delete_certificate_student
const deleteCertificateStudentAsync = ({ id }) => {
  return del(
    `/admin/course/course/certificate/assign/${id}`,
    {},
    { notify: true }
  );
};
// delete_certificate_student
function* DeleteCertificateStudent({ payload }) {
  try {
    const response = yield call(deleteCertificateStudentAsync, payload);
    yield put(deleteCertificateStudentSuccessful(response.data));
    yield put(getCertificateStudents({ id: payload.certificate_id }));
  } catch (error) {
    yield put(deleteCertificateStudentFailed(error));
  }
}

export function* watchMasterclass() {
  yield takeLatest(GET_CERTIFICATE_STUDENT, GetCertificateStudents);
  yield takeLatest(CREATE_CERTIFICATE_STUDENT, CreateCertificateStudent);
  yield takeLatest(UPDATE_CERTIFICATE_STUDENT, UpdateCertificateStudent);
  yield takeLatest(DELETE_CERTIFICATE_STUDENT, DeleteCertificateStudent);
}

export default function* rootSaga() {
  yield all([fork(watchMasterclass)]);
}
